interface Action {
    payload: any,
    type: string
}

const CasesReducer = (state = [], action: Action) => {
    switch (action.type) {
        case 'CASES_LIST':
            return action.payload;
        default:
            return state;
    }
};

export default CasesReducer;
